// extracted by mini-css-extract-plugin
export default {"intro":"OurCompany_intro__nD4V7","fadeInUp":"OurCompany_fadeInUp__NPlaL","growLine":"OurCompany_growLine__bbay-"};